import { Head, Link } from "@inertiajs/react"
import PublicLayout from "@/components/public/layout"
import type { SeoMeta } from "@/types"

export default function ComingSoon({ meta }: { meta: SeoMeta }) {
  return (
    <PublicLayout>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="robots" content="noindex" />
      </Head>

      <section className="px-6 py-24 md:py-32">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-red">
            Coming soon
          </p>
          <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-charcoal md:text-5xl">
            We&rsquo;re not quite ready<span className="text-red">.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-md text-lg text-slate">
            Sign-up and sign-in are on their way. In the meantime, have a look
            around.
          </p>
          <div className="mt-10">
            <Link
              href="/"
              className="inline-flex items-center rounded-md bg-red px-6 py-3 text-base font-medium text-white transition-colors hover:bg-deep-red"
            >
              Back to home
            </Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  )
}
